import { useState } from 'react';
import { CopyIcon } from '@radix-ui/react-icons';
import { mergeClasses } from '../utils/mergeClasses';

export interface CopyToClipboardProps {
  value: string;
  absolute?: boolean;
}

// Duration (in milliseconds) of how long success message is to be displayed
const SUCCESS_MESSAGE_DURATION = 4000;

export function CopyToClipboard({ value, absolute }: CopyToClipboardProps) {
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(value);
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, SUCCESS_MESSAGE_DURATION);
  };

  return (
    <div
      className={mergeClasses(
        'flex flex-row items-center gap-1',
        absolute ? 'absolute right-4 top-2' : ''
      )}
    >
      <div
        className={mergeClasses(
          'rounded-lg text-sm italic text-inpay-green-secondary-light-800',
          'transition-opacity duration-700',
          showSuccess ? 'opacity-100' : 'opacity-0'
        )}
      >
        Copied to clipboard!
      </div>
      <button
        data-testid="copy-clipboard-button"
        className="rounded-full bg-inpay-green-primary-1000/50 p-1.5 text-white hover:cursor-pointer hover:stroke-inpay-green-secondary-light-800"
        onClick={copyToClipboard}
      >
        <CopyIcon />
      </button>
    </div>
  );
}
